import Modal from "/WebInterface/new-ui/modules/modal.js";
import { applyCustomizations } from "/WebInterface/new-ui/modules/customizations/customizations.js";
import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import { growl } from "/WebInterface/new-ui/modules/toast.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import TagInput from "/WebInterface/new-ui/modules/tag-input/tag-input.js";
import MultiSelect from "/WebInterface/new-ui/modules/multi-select/multi-select.js";
import { getSharingCustomizations } from "/WebInterface/new-ui/modules/customizations/sharing-customizations.js";
import { validate } from "/WebInterface/new-ui/assets/js/utils/validate.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import { apiCall } from "/WebInterface/new-ui/assets/js/utils/api/apis.js";
import store from "/WebInterface/new-ui/store/index.js";
import {
  formTemplate,
  resultTemplate,
  errorResponseTemplate,
} from "./template.js";
import { ajax } from "/WebInterface/new-ui/assets/js/utils/ajax.js";
import { convertClassesToInlineStyles } from "/WebInterface/new-ui/assets/js/utils/sceditor-email-converter.js";

let currentShareBodyEditor;
let tagInput;
let multiSelect;
let autoCompleteElement;
let selectedFilesPath;

const extractFileName = (hrefPath) => {
  // Split the path by '/' and get the last element of the array
  const parts = hrefPath.split("/");
  return parts[parts.length - 1];
};

const addDays = (days) => {
  const date = new Date();
  date.setDate(date.getDate() + Number(days));

  return date;
};

const resolveShareExpireDate = (txtDate, customizations, data) => {
  const days = data?.txtdays ?? customizations?.EXPIREDAYS ?? 29;
  const n = Number(days);
  const fallback = addDays(!isNaN(n) ? n : 29);
  if (!txtDate) {
    return fallback;
  }
  const parsed = flatpickr.parseDate(txtDate, utils.getFlatpickrDateFormat());
  return parsed && !isNaN(parsed.getTime()) ? parsed : fallback;
};

const generateUsernamePassword = () => {
  const passwordLength =
    store.userInfo?.temp_accounts_length ||
    store?.userInfo?.random_password_length ||
    8;
  const generatedUser = utils.generatePassword(passwordLength);

  const passwordRule = {
    random_password_length: passwordLength,
    min_password_numbers: store?.userInfo.min_password_numbers,
    min_password_lowers: store?.userInfo.min_password_lowers,
    min_password_uppers: store?.userInfo.min_password_uppers,
    min_password_specials: store?.userInfo.min_password_specials,
    unsafe_password_chars: store?.userInfo.unsafe_password_chars,
    temp_link: true,
  };

  const generatedPassword = utils.generatePasswordBasedOnRules(passwordRule);

  return { generatedUser, generatedPassword };
};

const getShareFormData = (dialog, customizations = {}) => {
  const { shareMethod, hideShareMethod } = customizations;
  let formData = utils.serializeInputs(dialog.root, false, true);

  const hasShareTagInput =
    _$("#shareUsernames").el() &&
    _$("#shareUsernames").hasClass("autocomplete-wrapper");

  const hasShareMultiSelect =
    _$("#shareUsernames-multiselect").el() &&
    !_$("#shareUsernames-multiselect").hasClass("is-hidden");

  if (hasShareMultiSelect) {
    const { shareUsernames_multiselect } = utils.serializeInputs(
      _$("#shareUsernames-multiselect").parent().el(),
      false,
      false
    );
    formData = { ...formData, shareUsernames: shareUsernames_multiselect };
  } else if (hasShareTagInput) {
    const { shareUsernames } = utils.serializeInputs(
      _$("#shareUsernames").parent().el(),
      false,
      false
    );
    formData = { ...formData, shareUsernames };
  } else {
    formData = { ...formData, shareUsernames: _$("#shareUsernames").val() };
  }
  const defaults = { logins: -1, sendEmail: true, shareType: "external" };
  if (hideShareMethod && shareMethod) {
    defaults.shareType = shareMethod;
  }
  let emailText = getEditorValue();
  let shareBody = emailText
    .replace(
      '<span id="sceditor-end-marker" class="sceditor-selection sceditor-ignore lh-0 d-n"> </span><span id="sceditor-start-marker" class="sceditor-selection sceditor-ignore lh-0 d-n"> </span>',
      ""
    )
    .replace(
      '<span id="sceditor-start-marker" class="sceditor-selection sceditor-ignore lh-0 d-n"> </span><span id="sceditor-end-marker" class="sceditor-selection sceditor-ignore lh-0 d-n"> </span>',
      ""
    );

  return {
    ...defaults,
    ...formData,
    shareBody,
  };
};

export const initSharing = (data = {}) => {
  selectedFilesPath = data.paths.split("\r\n");
  const customizations = getSharingCustomizations(
    "normal",
    store?.userInfo?.userCustomizations || {}
  );
  tagInput = new TagInput();
  multiSelect = new MultiSelect();

  const footerInstructionTemplate = `
    <div class="w-full warning text-sm text-secondaryMain is-flex mb-3">
      <i class="icon-exclamation-sign"></i>
      <span>
       ${utils.sanitizePure(customizations?.shareWindowFooterInstructions || "")}
      </span>
    </div>`;

  customizations.sendEmail =
    typeof data.sendEmail === "undefined" || customizations.hideShareSendEmail
      ? (customizations.SENDEMAILDEFAULT ?? true)
      : data.sendEmail;

  const dialog = new Modal({
    title: "sharingFiles",
    body: formTemplate({
      ...data,
      ...customizations,
    }),
    closable: false,
    animate: false,
    movable: true,
    hasResizeOption: true,
    prependFooter: customizations?.shareWindowFooterInstructions
      ? footerInstructionTemplate
      : null,
    minWidth: "920px",
    minHeight: "900px",
    buttons: [
      {
        label: "cancel",
        close: true,
        classes: ["is-bordered", "mr-2"],
        onClick: () => {},
      },
      {
        label: "shareWindowSendButtonText",
        close: false,
        classes: [""],
        onClick: () => {
          console.log("12-> Share: Pressed Submit button #1", {
            customizations,
          });
          if (!customizations?.hideShareSendEmail) {
            const sendEmail = _$(dialog.root).find("#sendEmail", true);
            const emailFrom = _$(dialog.root).find("#emailFrom", true);
            const emailTo = _$(dialog.root).find("#emailTo", true);

            if (!sendEmail?.checked) {
              delete emailFrom?.dataset?.validate;
              delete emailTo?.dataset?.validate;
            } else {
              if (emailFrom) {
                emailFrom.dataset.validate = "required,email";
              }

              if (emailTo) {
                emailTo.dataset.validate = "required,multiple-emails";
              }

              const emailFromValueFromCustomization =
                utils.getUserCustomizationValue("EMAILFROM", true);
              const emailToValueFromCustomization =
                utils.getUserCustomizationValue("EMAILTO", true);

              if (
                (!emailFrom && !emailFromValueFromCustomization) ||
                (!emailTo && !emailToValueFromCustomization)
              ) {
                growl(
                  "",
                  t("emailFromAndToAreRequiredFieldsOrYouCanUncheckSendEmail"),
                  5000,
                  true
                );

                console.log(
                  "12-> Share: return from emailFromAndToAreRequiredFieldsOrYouCanUncheckSendEmail #2"
                );
                return;
              }
            }
          }

          const validateFields = validate(dialog.root, true);
          const isInternal =
            _$('input[name="shareType"]:checked').val() === "internal";
          if (
            isInternal &&
            !customizations.hideShareMethod &&
            !customizations.hideInternalShareMethod
          ) {
            if (!_$("#shareUsernames").hasClass("is-hidden")) {
              const shareUsernameValidation = validate(
                _$("#shareUsernames").el(),
                false
              );

              if (shareUsernameValidation?.length !== 0) {
                return;
              }
            }

            if (!_$("#shareUsernames-multiselect").hasClass("is-hidden")) {
              const shareUsernameValidation = validate(
                _$("#shareUsernames-multiselect").el(),
                false
              );

              if (shareUsernameValidation?.length !== 0) {
                return;
              }
            }
          }

          console.log("12-> Share: validateFields #3", validateFields);
          if (validateFields?.length !== 0) {
            console.log(
              "12-> Share: return from validateFields, length greater than 0 #4"
            );
            return;
          }

          const shareFormData = getShareFormData(dialog, customizations);
          store.dispatch("setShareDetails", shareFormData);
          submitSharingForm(dialog, shareFormData, data, customizations);
          console.log("12-> Share: Final form data #5", {
            shareFormData,
            data,
            customizations,
          });
        },
      },
    ],
    onBeforeHide: () => {
      if (tagInput) {
        tagInput.destroy();
      }
    },
  });

  // Enabling default permissions for Full access section when modify allow permission customization is enabled
  if (customizations?.shareAllowPrivsModification) {
    customizations?.shareAllowUploadsPrivs?.split(/[()]+/)?.forEach((perm) => {
      if (_$(`#priv_${perm}`).el()) {
        _$(`#priv_${perm}`).el().checked = true;
      }
    });
  }

  if (
    customizations?.shareWindowEnableUsernameLookup &&
    _$("#shareUsernames").el()
  ) {
    const handleUsernameDebounce = utils.debounce((e) => {
      const value = e?.target?.value;
      if (!value) {
        tagInput.updateOptions({
          autoComplete: autoCompleteElement,
          helperText: t("typeInASearchTerm"),
        });
        return;
      }

      tagInput.updateOptions({
        autoComplete: autoCompleteElement,
        helperText: `${t("searching")}...`,
      });

      ajax
        .call({
          method: "GET",
          urlEncoded: true,
          data: {
            command: "lookup_form_field",
            form_name: "share_form",
            form_element_name: "shareUsernames",
            q: value,
            skip_sort: !!customizations?.disable_share_usernames_sorting,
          },
        })
        .then((res) => {
          setTimeout(() => {
            const usernames = res?.map((item) => {
              return { value: item.id, label: item.name };
            });

            tagInput.updateOptions({
              autoComplete: autoCompleteElement,
              options: usernames || value,
            });
          }, 500);
        });
    }, 500);

    autoCompleteElement = tagInput.attach({
      input: "#shareUsernames",
      onInputChange: handleUsernameDebounce,
      helperText: t("typeInASearchTerm"),
      onClose: () => {
        tagInput.updateOptions({
          autoComplete: autoCompleteElement,
          options: false,
          helperText: t("typeInASearchTerm"),
        });
      },
    });
  }

  //

  if (
    customizations?.shareWindowEnableMultipleUsernameSelection &&
    _$("#shareUsernames-multiselect").el()
  ) {
    multiSelect.attach({
      input: "#shareUsernames-multiselect",
      leftLabel: t("availableUsers"),
      rightLabel: t("selectedUsers"),
    });

    ajax
      .call({
        data: {
          command: "lookup_form_field",
          form_name: "share_form",
          form_element_name: "shareUsernames",
          q: "",
          skip_sort: !!customizations?.disable_share_usernames_sorting,
        },
      })
      .then((res) => {
        const usernames = res?.map((item) => {
          return { value: item.id, label: item.name };
        });

        multiSelect.renderOptions({
          id: "shareUsernames-multiselect",
          options: usernames,
        });
      });
  }

  if (customizations.ShareDefaultLoginsValue) {
    _$("#logins").val(customizations.ShareDefaultLoginsValue);
  }

  bindSharingEvents(dialog, customizations);

  if (customizations.hideAdvancedOption) {
    const advancedFields = _$(dialog.root).find(".advanced");
    if (customizations.shareAdvanced) {
      advancedFields.each((el) => _$(el).removeClass("is-hidden"));
      _$(dialog.root).find(".generate").addClass("is-hidden");
      return;
    }
    advancedFields.remove();
  }

  if (customizations.splitShareRequests) {
    const autoRadio = _$(dialog.root).find("#ShareGeneratePassAuto");
    const generateRadio = _$(dialog.root).find("#ShareGeneratePass");
    if (autoRadio.length > 0) {
      autoRadio.el().checked = true;
    }
    if (generateRadio.length > 0) {
      generateRadio.el().disabled = true;
    }
  }

  return dialog;
};

const getShareValues = (values, data) => {
  const customizations = getSharingCustomizations(
    "normal",
    store?.userInfo?.userCustomizations || {}
  );

  if (
    data.shareType.toLowerCase() === "external" &&
    customizations.forceGeneratePasswordShare &&
    !customizations.splitShareRequests
  ) {
    const generatePass = data?.temp_password;
    const generateUser = data?.temp_username;

    if (!generatePass || !generateUser) {
      growl(t("pleaseSelectUserPassForTheShare"), "", 5000, true);
      return false;
    }

    if (
      generatePass.length < 4 ||
      generateUser.length < 4 ||
      generatePass.length > 50 ||
      generateUser.length > 50
    ) {
      growl(
        t("selectedUserPassForTheShareWasDeniedPleaseChooseOtherUserPass"),
        "",
        5000,
        true
      );
      return false;
    }
  }

  if (customizations.customShareLinkURL) {
    values.baseUrl = customizations.customShareLinkURL;
  }
  values.shareUsername =
    typeof values.shareUsername !== "undefined"
      ? values.shareUsername
      : customizations.shareMethod && customizations.shareMethod === "internal";

  values.allowUploads =
    typeof values.allowUploads !== "undefined"
      ? values.allowUploads
      : customizations.shareAllowUploads === "true" || data.priv_write === true;

  const txtDate = resolveShareExpireDate(data.txtDate, customizations, data);

  values.expire = utils.formatDateTimeForApi(txtDate, data.txtTime);

  console.log("Share form values before customizations:", { ...values }); //eslint-disable-line

  if (typeof values.emailFrom === "undefined") {
    values.emailFrom = customizations.EMAILFROM || "";
  }
  if (typeof values.emailTo === "undefined") {
    values.emailTo = customizations.EMAILTO || "";
  }

  if (typeof values.emailBcc === "undefined") {
    values.emailBcc = customizations.EMAILBCC || "";
  }

  if (typeof values.emailReplyTo === "undefined") {
    values.emailReplyTo = customizations.EMAILREPLYTO || "";
  }

  if (typeof values.emailCc === "undefined") {
    values.emailCc = customizations.EMAILCC || "";
  }

  if (typeof values.emailSubject === "undefined") {
    values.emailSubject = customizations.EMAILSUBJECT || "";
  }

  if (
    typeof values.emailBody === "undefined" ||
    customizations.hideShareBodyRow
  ) {
    values.emailBody =
      values.emailBody ||
      customizations.defaultEmailBody ||
      "A user would like to share a file with you. This link will expire on {date} at {time}.\n\n{web_link}";
  }

  if (typeof values.publishType === "undefined") {
    values.publishType = customizations.defaultShareMethod || "reference";
  }

  if (typeof values.shareUsername === "undefined") {
    values.shareUsername = customizations.SHAREMETHOD
      ? customizations.SHAREMETHOD === "internal"
      : true;
  }

  if (typeof values.attach === "undefined") {
    values.attach = customizations.shareThumbnail || true;
  }

  if (typeof values.attach_real === "undefined") {
    values.attach_real = customizations.shareFiles || false;
  }

  if (!values.shareUsernamePermissions) {
    values.shareUsernamePermissions =
      customizations?.shareAllowPrivsModification
        ? ""
        : "(read)(resume)(view)(slideshow)";

    if (data.fullaccess && !customizations?.shareAllowPrivsModification) {
      values.shareUsernamePermissions =
        customizations?.shareAllowUploadsPrivs || "";
    }

    if (typeof data.fullaccess === "undefined") {
      values.allowUploads = customizations.shareAllowUploads || false;
      if (values.allowUploads) {
        values.shareUsernamePermissions =
          customizations?.shareAllowUploadsPrivs ||
          values.shareUsernamePermissions ||
          "";
      }
    } else if (data.fullaccess) {
      values.shareUsernamePermissions = values.shareUsernamePermissions || "";
    }

    values.shareUsernamePermissions = utils.removeDuplicatesPermissions(
      values.shareUsernamePermissions
    );
  }

  if (typeof data.logins === "undefined" || customizations.hideShareLoginsRow) {
    values.logins = customizations.ShareDefaultLoginsValue || -1;
  }

  if (typeof data.hide_download === "undefined") {
    values.hide_download =
      customizations.shareWindowHideDownloadButtonVisibleDefaultVal || false;
  }

  values.sendEmail =
    typeof data.sendEmail === "undefined" || customizations.hideShareSendEmail
      ? (customizations.SENDEMAILDEFAULT ?? true)
      : data.sendEmail;

  console.log("Share form values after customizations:", { ...values }); //eslint-disable-line

  return true;
};

const submitSharingForm = (dialog, data, info) => {
  const customizations = getSharingCustomizations(
    "normal",
    store?.userInfo?.userCustomizations || {}
  );

  let obj = {};
  let baseURL = document.location.href + "";
  if (baseURL.indexOf("#") >= 0)
    baseURL = baseURL.substring(0, baseURL.indexOf("#"));

  let shareUsernamePermissionsStr = "";
  for (const key in data) {
    if (key.startsWith("priv_") && data[key]) {
      shareUsernamePermissionsStr += `(${key.replace("priv_", "")})`;
      if (data.shareType === "internal") {
        shareUsernamePermissionsStr += "(view)";
      }
      if (!data.fullaccess) {
        if (key.replace("priv_", "") === "write") {
          shareUsernamePermissionsStr += `(rename)(makedir)`;
          if (data.shareType === "internal") {
            shareUsernamePermissionsStr += "(view)";
          }
        } else if (key.replace("priv_", "") === "delete") {
          shareUsernamePermissionsStr += `(deletedir)`;
          if (data.shareType === "internal") {
            shareUsernamePermissionsStr += "(view)";
          }
        }
      }
    }
  }

  if (
    !shareUsernamePermissionsStr &&
    customizations?.shareWindowHidePermissions &&
    customizations?.shareWindowDefaultPermissions &&
    customizations.shareWindowDefaultPermissions.trim() !== "" &&
    data.shareType === "internal" &&
    !customizations?.shareAllowPrivsModification
  ) {
    const defaultPerms = customizations.shareWindowDefaultPermissions
      .split(",")
      .map((p) => p.trim().toLowerCase())
      .filter((p) => p);

    defaultPerms.forEach((perm) => {
      if (perm === "download") {
        shareUsernamePermissionsStr += "(read)";
        shareUsernamePermissionsStr += "(view)";
      } else if (perm === "upload") {
        shareUsernamePermissionsStr += "(write)";
        shareUsernamePermissionsStr += "(view)";
        if (!data.fullaccess) {
          shareUsernamePermissionsStr += "(rename)(makedir)";
        }
      } else if (perm === "delete") {
        shareUsernamePermissionsStr += "(delete)";
        shareUsernamePermissionsStr += "(view)";
        if (!data.fullaccess) {
          shareUsernamePermissionsStr += "(deletedir)";
        }
      }
    });
  }

  const allowUploads =
    typeof data.fullaccess !== "undefined" ? data.fullaccess : data.priv_write;

  const txtDate = resolveShareExpireDate(data.txtDate, customizations, data);

  obj = {
    allowUploads: allowUploads,
    attach: data.attach,
    hide_download: data.hide_download,
    attach_real: data.attach_real,
    baseUrl: utils.encodeURILocal(baseURL),
    emailBcc: data?.emailBcc
      ? utils.stripDownEmails(data?.emailBcc)
      : data?.emailBcc,
    emailReplyTo: data?.emailReplyTo
      ? utils.stripDownEmails(data?.emailReplyTo)
      : data?.emailReplyTo,
    emailBody: data.shareBody
      ? utils.encodeURILocal(data.shareBody)
      : data.shareBody,
    share_comments: data?.share_comments
      ? utils.encodeURILocal(data?.share_comments)
      : data?.share_comments,
    emailCc: data?.emailCc
      ? utils.stripDownEmails(data?.emailCc)
      : data?.emailCc,
    emailFrom: data?.emailFrom
      ? utils.stripDownEmails(data?.emailFrom)
      : data?.emailFrom,
    emailSubject: data?.emailSubject
      ? utils.encodeURILocal(data?.emailSubject)
      : data?.emailSubject,
    emailTo: data?.emailTo
      ? utils.stripDownEmails(data?.emailTo)
      : data?.emailTo,
    shareUsername: data.shareType
      ? data.shareType === "internal"
      : data.shareType,
    shareUsernames: data.shareUsernames,
    shareUsernamePermissions: utils.removeDuplicatesPermissions(
      shareUsernamePermissionsStr
    ),
    expire: utils.formatDateTimeForApi(txtDate, data.txtTime),
    paths: utils.encodeURILocal(info.paths),
    publishType: data.publishType,
    logins: data.logins,
    sendEmail: data.sendEmail,
    direct_link:
      data.direct_link ||
      utils.getUserCustomizationValue("shareWindowFlagDirectLinkForFile") ||
      false,
  };

  const hideUserGenerationOption = customizations?.hideUserGenerationOption;
  const hidePassGenerationOption = customizations?.hidePassGenerationOption;
  if (
    data.generateUserPass === "generate" &&
    (hideUserGenerationOption || hidePassGenerationOption)
  ) {
    const { generatedUser, generatedPassword } = generateUsernamePassword();
    if (hideUserGenerationOption) {
      data.temp_username = generatedUser;
    }
    if (hidePassGenerationOption) {
      data.temp_password = generatedPassword;
    }
  }

  const canPassShareValue = getShareValues(obj, data);
  if (!canPassShareValue) {
    return;
  }

  if (!customizations.splitShareRequests) {
    if (data?.temp_username) {
      obj.temp_username = data.temp_username || "";
    }

    if (data?.temp_password) {
      obj.temp_password = data.temp_password || "";
    }
  }

  const fileNames = selectedFilesPath.map(extractFileName);
  try {
    if (obj.emailBody) {
      obj.emailBody = obj.emailBody.replace(
        /{files}/g,
        fileNames.map((n) => utils.doubleEncodeHtml(n)).join("\r\n")
      );
    }
  } catch (e) {}

  const loading = new Loader({
    parentElement: `#modal_${dialog.options.uniqueId} .modal-card`,
  });

  // Handle multiple email requests when splitShareRequests is enabled
  if (customizations.splitShareRequests && obj.emailTo) {
    const emailTo = obj.emailTo;
    const emailList = emailTo
      .split(",")
      .map((email) => email.trim())
      .filter((email) => email);
    obj.to_all = emailTo;

    if (emailList.length > 1) {
      // Sequentially call API for each email
      let lastResponse = null;
      emailList
        .reduce((promiseChain, email) => {
          return promiseChain.then(() => {
            const { generatedUser, generatedPassword } =
              generateUsernamePassword();
            const emailObj = {
              ...obj,
              emailTo: email,
              temp_username: generatedUser,
              temp_password: generatedPassword,
            };
            console.log("12-> Share: publish API call #6", { ...emailObj }); //eslint-disable-line
            return apiCall("publish", { ...emailObj }).then((response) => {
              lastResponse = response;
            });
          });
        }, Promise.resolve())
        .then(() => {
          if (lastResponse) {
            handlePublishResponse(
              lastResponse,
              dialog,
              obj,
              data,
              info,
              fileNames,
              loading
            );
          } else {
            throw new Error("No share responses received");
          }
        })
        .catch((err) => {
          console.log(err);
          loading.deleteLoader();
        });
      return;
    } else {
      const { generatedUser, generatedPassword } = generateUsernamePassword();
      obj.emailTo = emailList[0] || emailTo;
      obj.temp_username = generatedUser;
      obj.temp_password = generatedPassword;
    }
  }

  if (
    customizations.splitShareRequests &&
    !obj.temp_username &&
    !obj.temp_password
  ) {
    const { generatedUser, generatedPassword } = generateUsernamePassword();
    obj.temp_username = generatedUser;
    obj.temp_password = generatedPassword;
  }

  console.log("12-> Share: publish API call #6", { ...obj });
  apiCall("publish", {
    ...obj,
  })
    .then((response) => {
      handlePublishResponse(
        response,
        dialog,
        obj,
        data,
        info,
        fileNames,
        loading
      );
    })
    .catch((err) => {
      console.log(err);
      loading.deleteLoader();
    });
};

const handlePublishResponse = (
  response,
  dialog,
  obj,
  data,
  info,
  fileNames,
  loading
) => {
  const { commandResult } = response;
  const shareDisableNotificationPopup = utils.getUserCustomizationValue(
    "shareDisableNotificationPopup"
  );
  const normalShareOpenEmailClient = utils.getUserCustomizationValue(
    "normalShareOpenEmailClient"
  );

  if (shareDisableNotificationPopup) {
    dialog.hide(true);
    if (normalShareOpenEmailClient) {
      const emailToClient = utils
        .decodeURILocal(commandResult.response.message)
        .match(/href="([^"]*)/)[1];
      const link = utils.getEmailClientLink(emailToClient, [
        { varToReplace: "{files}", value: fileNames.join("\r\n") },
      ]);
      const urlToOpen = link
        .replace(/\r/g, "%0D%0A")
        .replace(/%3Cbr%3E/gi, "%0D%0A");
      window.open(urlToOpen, "_blank");
    }
    loading.deleteLoader();
    return;
  }

  let errorMessage = utils.htmlToPlainText(
    utils.decodeURILocal(commandResult?.response?.message)
  );

  const hasErrorInResponse =
    errorMessage?.toLowerCase().indexOf("share_complete") < 0 &&
    (errorMessage?.toLowerCase().indexOf("error") >= 0 ||
      errorMessage?.toLowerCase().indexOf("denied") >= 0);
  const hasEmailFailed =
    !utils.getUserCustomizationValue("shareWindowResultDisableSMTPError") &&
    errorMessage.indexOf("ERROR") == 0 &&
    errorMessage.indexOf("email_failed") > 0;

  if (hasEmailFailed) {
    errorMessage = t("sendingEmailFailed");
  }

  let buttons = [
    {
      label: "ok",
      close: true,
      classes: [""],
      onClick: () => {},
    },
  ];

  const shareWindowNoOpenInEmail = utils.getUserCustomizationValue(
    "shareWindowNoOpenInEmail"
  );
  const shareHideCopyLinkButton = utils.getUserCustomizationValue(
    "shareHideCopyLinkButton"
  );
  const shareWindowNoUserInfoAfterShare = utils.getUserCustomizationValue(
    "shareWindowNoUserInfoAfterShare"
  );
  const hideShareResultLink = utils.getUserCustomizationValue(
    "hideShareResultLink"
  );

  if (!hasErrorInResponse) {
    buttons.unshift({
      label: "openInEmailClient",
      classes: [
        "primary-button",
        "is-bordered",
        "mr-2",
        shareWindowNoOpenInEmail && "is-hidden",
      ],
      id: "openInEmailClient-share",
      onClick: () => {
        const emailToClient = utils
          .decodeURILocal(commandResult.response.message)
          .match(/href="([^"]*)/)[1];
        const link = utils.getEmailClientLink(emailToClient, [
          { varToReplace: "{files}", value: fileNames.join("\r\n") },
        ]);
        const urlToOpen = link
          .replace(/\r/g, "%0D%0A")
          .replace(/%3Cbr%3E/gi, "%0D%0A");
        window.open(urlToOpen, "_blank");
      },
    });

    if (!shareHideCopyLinkButton && !data.shareUsernames) {
      buttons.unshift({
        label: "copyLinkToClipboard",
        classes: ["primary-button", "is-bordered", "mr-2"],
        onClick: () => {
          navigator.clipboard.writeText(
            utils.decodeURILocal(commandResult.response.url)
          );
          const canDontClosePopupOnClip = utils.getUserCustomizationValue(
            "dontClosePopupOnClip"
          );
          if (!canDontClosePopupOnClip) {
            dialog.hide(true);
          }
          growl(t("linkCopiedToClipboard"), "", 5000);
        },
      });
    }
  }

  if (!hasErrorInResponse && obj.publishType === "move") {
    store.dispatch("refreshListing");
  }

  console.log("12-> Share: dialog update after published #7", {
    hasErrorInResponse,
    errorMessage,
    obj,
    commandResult,
    data,
    info,
  });
  dialog.update({
    title: hasErrorInResponse ? t("publishFailed") : t("publishCompleted"),
    prependFooter: null,
    body: hasErrorInResponse
      ? errorResponseTemplate({
          errorMessage,
        })
      : resultTemplate({
          ...data,
          ...info,
          ...commandResult.response,
          hasEmailFailed,
          shareWindowNoUserInfoAfterShare,
          hideShareResultLink,
          url: utils.decodeURILocal(commandResult.response.url),
        }),
    minWidth: "650px",
    minHeight: "365px",
    buttons,
  });

  if (normalShareOpenEmailClient) {
    _$("#modal-btn-openInEmailClient-share").el()?.click();
  }

  if (!hasErrorInResponse && commandResult?.response) {
    const shareResultPasswordEl = document.getElementById(
      "shareResultPassword"
    );
    if (shareResultPasswordEl) {
      shareResultPasswordEl.textContent =
        `${commandResult.response.password}` || "";
    }
    const shareResultURLEl = document.getElementById("shareResultURL");
    if (shareResultURLEl) {
      shareResultURLEl.textContent =
        `${utils.decodeURILocal(commandResult.response.url || "")}` || "";
    }
  }

  // TODO: refactor this unused code, Need to remove if condition
  if (_$(dialog.root).find("a[href^='mail']").length > 0) {
    let text = utils.decodeURILocal(
      _$(dialog.root).find("a[href^='mail']").attr("href")
    );
    if (text.indexOf("{files}") >= 0) {
      if (info.files) {
        let sub = info.files.substring(0, 250);
        if (info.files.length > 250) sub += "...";
        text = text.replace(/{files}/g, sub);
      } else {
        let sub = info.files.substring(0, 250);
        if (info.files.length > 250) sub += "...";
        text = text.replace(/{files}/g, sub);
      }
    }
    text = text.replace(/\r/g, "%0D%0A");
    let _sub = text.split("&body=")[0];
    let _asub = utils.decodeURILocal(text.split("&body=")[1]);
    _asub = _asub.replace(/<\/?[^>]+(>|$)/g, ""); //remove tags
    text = _sub + "&body=" + utils.encodeURILocal(_asub);

    _$(dialog.root).find("a[href^='mail']").attr("href", text);
  }

  loading.deleteLoader();
};

export const updateEditor = (text) => {
  const fileNames = selectedFilesPath.map(extractFileName);
  try {
    const editor = sceditor.instance(currentShareBodyEditor);
    if (editor) {
      if (text) {
        text = text.replace(/-NEW-LINE-/g, "<br />");
      }
      let template = text || editor.val();

      const parser = new DOMParser();
      const doc = parser.parseFromString(template, "text/html");

      if (doc.body.children.length < 1) {
        template = template.replace(/\n/g, "<br />");
      }

      template = template.replace(
        /{files}/g,
        fileNames
          .map((name) => `<p>${utils.doubleEncodeHtml(name)}</p>`)
          .join("")
      );
      editor.val(template);
    }
  } catch (e) {
    console.log(e);
  }
};

export const getEditorValue = () => {
  if (!currentShareBodyEditor) {
    return "";
  }
  const editor = sceditor?.instance(currentShareBodyEditor);
  let html = "";
  if (editor) {
    html = editor.val();
  } else {
    html = _$(currentShareBodyEditor).val();
  }

  // Convert CSP-compliant classes to inline styles for email compatibility
  // Email clients don't support external CSS, so inline styles are required
  if (html && typeof convertClassesToInlineStyles !== "undefined") {
    return convertClassesToInlineStyles(html);
  }

  return html;
};

const bindSharingEvents = (dialog, customizations) => {
  const { root } = dialog;
  const parent = _$(root);
  currentShareBodyEditor = parent.find("#emailBody", true);

  if (currentShareBodyEditor && !customizations.shareEmailBodyNoHTMLArea) {
    sceditor.create(currentShareBodyEditor, {
      format: "xhtml",
      emoticonsEnabled: false,
      width: "100%",
      readOnly: customizations.readonlyShareBody,
      toolbarExclude:
        "emoticon,youtube,table,code,quote,horizontalrule,image,email,link,unlink,emoticon,youtube,date,time,ltr,rtl,print,maximize,",
      style:
        "/WebInterface/new-ui/assets/js/thirdparty/SCEditor/themes/content/default.min.css",
    });

    const theme = localStorage.getItem("data-theme");
    // Use CSSOM instead of .css() to avoid CSP violation
    const editorInstance = sceditor.instance(currentShareBodyEditor);
    if (editorInstance && editorInstance.getBody) {
      const editorBody = editorInstance.getBody();
      if (editorBody && editorBody.style) {
        editorBody.style.setProperty(
          "color",
          theme === "dark" ? "#ffffff" : "#222222"
        );
      }
    }
  }

  applyCustomizations(parent);

  if (!customizations.hideShareExpiresRow) {
    const daysElement = parent.find("#txtdays", true);

    if (customizations.EXPIREDAYSMAX) {
      daysElement.setAttribute("data-validate", "max-value,min-value");
      daysElement.setAttribute("data-max-value", customizations.EXPIREDAYSMAX);
      daysElement.setAttribute("max", customizations.EXPIREDAYSMAX);
      daysElement.setAttribute("data-min-value", 0);
      daysElement.setAttribute("data-mark-error", "true");
      daysElement.setAttribute("data-inline-error", "true");
    }

    const calendar = flatpickr("#date-picker", {
      dateFormat: utils.getFlatpickrDateFormat(),
    });

    const timePickerElement = flatpickr(
      "#time-picker",
      utils.getFlatpickrTimePickerOptions()
    );

    calendar.setDate(addDays(daysElement.value || 29));
    timePickerElement.setDate(66540000);

    _$(daysElement).on("input", (e) => {
      const days = e.target.value;

      // set value of calendar
      calendar.setDate(addDays(days));
    });
  }

  const handleClickOnGenerateButton = () => {
    const { generatedUser, generatedPassword } = generateUsernamePassword();

    _$("#share_generate_user").val(generatedUser);
    _$("#share_generate_pass").val(generatedPassword);
  };

  _$("#shareGenerateUserPass").on("click", handleClickOnGenerateButton);

  const bindOptionChange = ({
    selector,
    enable,
    disable,
    validate,
    callback,
    defaultVal,
  }) => {
    const trigger = () => {
      const toEnable = enable && parent.find(enable);
      const toDisable = disable && parent.find(disable);
      const elem = parent.find(`${selector}:checked`);
      if (callback) callback(elem, selector);

      if ((elem && elem.length > 0) || typeof defaultVal !== "undefined") {
        const validation = !validate || validate(elem.val() || defaultVal);
        toEnable?.each((el) => _$(el).toggleClass("is-hidden", !validation));
        toDisable?.each((el) => _$(el).toggleClass("is-hidden", validation));
      } else {
        toEnable?.each((el) => _$(el).addClass("is-hidden"));
        toDisable?.each((el) => _$(el).removeClass("is-hidden"));
      }
    };
    parent.find(selector).each((input) => {
      _$(input).on("change", trigger);
    });
    trigger();
  };

  bindOptionChange({
    selector: 'input[type="checkbox"][name="shareUsernameInput"]',
    enable: ".multiselect-wrapper",
    disable: ".autocomplete-wrapper",
    validate: (value) => value === "multiselect",
    defaultVal: customizations?.hideShareMultipleSelectionQuick
      ? customizations?.shareWindowEnableMultipleUsernameSelection
        ? "multiselect"
        : undefined
      : undefined,
    callback: () => {
      const checkboxEl = _$("#shareUsernameInput").el();
      const isChecked = checkboxEl
        ? _$("#shareUsernameInput").prop("checked")
        : customizations?.shareWindowEnableMultipleUsernameSelection;
      if (isChecked) {
        const hasShareTagInput =
          _$("#shareUsernames").el() &&
          !_$("#shareUsernames").hasClass("is-hidden");

        if (hasShareTagInput) {
          const options = tagInput.getSelectedOptions({ id: "shareUsernames" });

          multiSelect.updateSelectedOptions({
            id: "shareUsernames-multiselect",
            options: options,
          });
        }
      } else {
        const hasShareMultiSelect =
          _$("#shareUsernames-multiselect").el() &&
          !_$("#shareUsernames-multiselect").hasClass("is-hidden");

        if (hasShareMultiSelect) {
          const options = multiSelect.getSelectedOptions(
            "shareUsernames-multiselect"
          );

          if (tagInput) {
            tagInput.updateSelectedOption({
              id: "shareUsernames",
              options: options,
              autoComplete: autoCompleteElement,
            });
          }
        }
      }
    },
  });

  bindOptionChange({
    selector: 'input[type="radio"][name="shareType"]',
    enable: ".internal",
    disable: ".external",
    validate: (value) => value === "internal",
    defaultVal: customizations.shareMethod,
  });

  // if (customizations.hideShareMethod) {
  //   const value = customizations.shareMethod || "external";
  //   const disable = value === "internal" ? ".internal" : ".external";
  //   const enable = value === "internal" ? ".external" : ".internal";
  //   const toEnable = enable && parent.find(enable);
  //   const toDisable = disable && parent.find(disable);
  //   toEnable?.each((el) => _$(el).addClass("is-hidden"));
  //   toDisable?.each((el) => _$(el).removeClass("is-hidden"));
  // }
  bindOptionChange({
    selector: 'input[type="radio"][name="generateUserPass"]',
    enable: ".generate",
    disable: null,
    validate: (value) => value === "generate",
    callback: (elem, selector) => {
      if (customizations.splitShareRequests) {
        const autoRadio = _$(dialog.root).find("#ShareGeneratePassAuto");
        const generateRadio = _$(dialog.root).find("#ShareGeneratePass");
        if (autoRadio.length > 0) {
          autoRadio.el().checked = true;
        }
        if (generateRadio.length > 0) {
          generateRadio.el().disabled = true;
        }
      } else {
        handleClickOnGenerateButton();
      }
    },
  });

  bindOptionChange({
    selector: 'input[type="checkbox"][name="advanced"]',
    enable: ".advanced",
    callback: () => {
      if (customizations.splitShareRequests) {
        const autoRadio = _$(dialog.root).find("#ShareGeneratePassAuto");
        const generateRadio = _$(dialog.root).find("#ShareGeneratePass");
        if (autoRadio.length > 0) {
          autoRadio.el().checked = true;
        }
        if (generateRadio.length > 0) {
          generateRadio.el().disabled = true;
        }
      }
    },
  });

  bindOptionChange({
    selector: 'input[type="checkbox"][id="fullaccess"]',
    enable: ".fullaccess",
  });
};
